export const Dashboard = {
  list: function () {
    var options = {
      bDestroy: true,
      bDeferRender: true,
      data: JSON.parse(jQuery("#dashboard-list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#dashboard-name-template").html().replace("__label__", data.label).replace("__href__", data.href).replace("__icon__", data.icon)
            } else {
              return data.label;
            }
          },
          targets: [0],
        },
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return data.join(", ");
            }
            return data;
          },
          targets: [2],
        },
        {
          targets: [4],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        DataTablesHelper.addColumnFilters(this);
        ActionJS.Dashboard.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var table = jQuery("#dashboard-list");
    table.DataTable(options);

    jQuery(document).on("click", ".copy-public-dashboard-link", function () {
      var url = window.location.protocol + '//' + window.location.hostname + jQuery(this).data('link')
      navigator.clipboard.writeText(url)
    })
  },

  show: function () {
    ActionJS.Report.dashboard();
  },

  edit_widgets: function () {
    ActionJS.Dashboard.show();
    const dashboardName =  $('#dashboard-name').length ? `Edit: ${$('#dashboard-name').attr('data-dashboard-name')}` : I18n.t('manage_dashboards');
    // Edit only the text, the cavet icon also in the div so need to take first text
    $('#dashboard-header-name').contents().filter(function() {
        return this.nodeType === 3; // Text node
    }).first().replaceWith(dashboardName);
  },

  edit_user_types: function () {
    jQuery(".select2").select2();
  },

  priv: {
    bindEvent: function () {
      jQuery(".dashboard-clone-link, .dashboard-delete-link")
        .off("click")
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data("confirm")) {
            c = confirm(jQuery(this).data("confirm"));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr("href"),
                method: "POST",
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
              })
              .done(function (d) {
                Turbo.visit(window.location.href);
              });
          }
          e.preventDefault();
        });
    },
  },
};
